<h1 mat-dialog-title>{{ title }}</h1>
<hr>

<form id="form" autocomplete="off" [formGroup]="form" (ngSubmit)="enviar()">
  <mat-dialog-content>
    <div class="row">
      <div class="col-12 col-sm-12 col-md-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Marca</mat-label>
          <input matInput formControlName="marca" placeholder="Marca"
            (blur)="form.controls['marca'].markAsTouched()" uppercase alphanumericOnly maxlength="50">
          <mat-error *ngIf="isValidField('marca')">
            {{ getFieldError('marca') }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button color="primary" class="m-1" type="submit" *ngIf="mostrarBoton">
      <i class="fa fa-save"></i> Guardar
    </button>
    <button mat-raised-button color="warn" class="m-1" mat-dialog-close>
      <i class="fa fa-remove fa-solid"></i> Cancelar
    </button>
  </mat-dialog-actions>
</form>